import {
  ProductAvailabilityTierBatchCreateRequestType,
  ProductAvailabilityTierBatchCreateResponseType,
} from "@sellar-io/api-v2/types";
import { useMutation, useQueryClient } from "@tanstack/react-query";

import { useFirebaseUser } from "../../../useFirebaseUser.shared";
import { useSellarCurrentBusiness } from "../../../useSellarCurrentBusiness.shared";
import { apiV2AssertResponse, apiV2Request } from "../apiV2Request";
import { ServerStateKeys } from "../ServerStateKeys";

export const useProductAvailabilityTierBatchCreate = () => {
  const queryClient = useQueryClient();
  const { business } = useSellarCurrentBusiness();
  const { user } = useFirebaseUser();

  return useMutation({
    mutationFn: (data: ProductAvailabilityTierBatchCreateRequestType) =>
      apiV2Request({
        user,
        business,
        method: "post",
        path: `product-availability-tiers/batch-create`,
        data,
      }).then(
        (data) =>
          apiV2AssertResponse(data)
            .data as ProductAvailabilityTierBatchCreateResponseType,
      ),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [user?.uid, business?.id, ServerStateKeys.Products],
      });
      queryClient.invalidateQueries({
        queryKey: [business?.id, ServerStateKeys.ProductAvailabilityTiers],
      });
      queryClient.invalidateQueries({
        queryKey: [business?.id, ServerStateKeys.Products],
      });
    },
  });
};
